import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useAccountCardAPI() {
  const { userRef, menuIdRef, languageRef } = useStorage();

  function findAccountCardsFromRemote() {
    const url = `/vbeta2/account/cards`;

    return axios({
      url,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  function deleteAccountCardFromRemote(id) {
    const url = `/vbeta2/account/cards/${id}`;

    return axios({
      url,
      method: 'delete',
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
        Authorization: `Bearer ${userRef?.current?.token}`,
      },
      responseType: 'json',
    });
  }

  return {
    findAccountCardsFromRemote,
    deleteAccountCardFromRemote,
  };
}

export { useAccountCardAPI };
